import { Typography, Variables } from '@catapultsports/referee-react';
import { IconErrorWarningSmall } from '@catapultsports/referee-react/icons';
import * as React from 'react';
import { Detector } from 'react-detect-offline';

interface OfflineBannerProps {
    testId?: string;
}

export const OfflineBanner: React.FunctionComponent<OfflineBannerProps> = ({ testId }) => (
    <Detector
        polling={{
            url: `${process.env.REACT_APP_API_HOST}/ping`,
            interval: 30000,
            enabled: true,
            timeout: 10000,
        }}
        render={({ online }) => {
            const height = 28;
            return (
                <>
                    <div
                        data-testid={testId}
                        style={{
                            background: Variables.css?.alert,
                            color: Variables.css?.catapultWhite,
                            boxShadow: Variables.css?.shadow1,
                            height: height,
                            marginTop: online ? -1 * height : 0,
                            transitionProperty: 'all',
                            transitionDuration: '500ms',
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            top: 0,
                            width: '100vw',
                            gap: 8,
                        }}
                    >
                        <IconErrorWarningSmall />
                        <Typography variant="body-2" style={{ color: Variables.css?.catapultWhite }}>
                            Internet connection lost
                        </Typography>
                    </div>
                </>
            );
        }}
    />
);
